import { ComponentClass } from 'react';
export { ComponentClass };
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ActivityFeed" */ './lazyIndex')
);

export let ActivityFeed = createLazyComponent(lazyModule, m => m.ActivityFeed);
let lazyInitializeActivityFeed = new LazyAction(lazyModule, m => m.initializeActivityFeed);

runAfterInitialRender(() => lazyInitializeActivityFeed.importAndExecute());
export { ActivityType } from './service/ActivityFeedStorageItem';
